import styled from "styled-components";
import { Modal } from "react-bootstrap";

export const ModalStyle = styled(Modal)`
  .modal-content {
    max-width: 648px;
    width: 100%;
    border-radius: 10px;
  }
  .modal-dialog-centered {
    max-width: 648px !important;
    place-content: center;
  }
`;

export const ContentButtons = styled.div`
  display: flex;
  justify-content: space-around;

  button {
    width: 40%;
  }
`;

export const ModalContainer = styled.div`
  padding: 28px 28px 39px 28px;
  width: 100%;

  @media (max-width: 768px) {
    padding: 18px;
    width: 100%;
  }
`;

export const ModalHeader = styled.header`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;

  div {
    display: flex;
    place-content: space-between;

    h2 {
      margin: 0;
      color: #0b24fb;
      font-size: 18px;
      font-weight: 400;
    }
  }

  svg {
    color: ${({ theme }) => theme.colors.darkBlue};
    cursor: pointer;
    margin-left: 10px;
  }
`;

export const ModalBody = styled.div`
  background-color: white;
  box-shadow: #00000029 0px 3px 6px;
  border: 1px solid #e2e2e2;
  border-radius: 5px;
  padding: 18px 16px 18px 16px;

  display: grid;
  grid-template-columns: auto auto;
  column-gap: 17px;

  margin-bottom: 20px;

  div p {
    font-size: 0.8125rem;
    font-weight: 400;
    line-height: 15px;
    margin: 0;
    margin-bottom: 31px;

    @media (max-width: 768px) {
      text-align: center;
    }

    strong {
      color: #000000;
      font-weight: bold;
      line-height: 18px;
      text-align: left;
    }
  }

  @media (max-width: 768px) {
    grid-template-columns: auto;
    place-self: center;
    place-items: center;
    place-content: center;
    height: auto;
  }
`;

export const ContentIcon = styled.div`
  height: 57px;
  width: 57px;
  border-radius: 50%;
  background-color: #f2f2f2;
  color: #4d565c;
  display: flex;
  place-content: center;
  place-items: center;
`;

export const InfoCard = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  place-content: space-between;
  column-gap: 45px;
  row-gap: 23px;

  p {
    margin: 0 !important;
  }

  @media (max-width: 768px) {
    grid-template-columns: auto;
    place-self: center;
    place-items: center;
    place-content: center;
    height: auto;

    p {
      display: flex;
      flex-direction: column;
      place-content: center;
      place-items: center;
      text-align: center;
    }
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  button {
    width: 160px;

    &:first-child {
      margin-right: 16px;
      width: 130px;
    }
  }
`;
